import { Box, Button, DialogActions, Modal, Stack, Typography } from '@mui/material'
import type React from 'react'
import { useContext, useEffect, useRef } from 'react'
import { LanguageContext } from '../util/LanguageContext'

type ModalAddDuplicateDialogProps = {
  open: boolean
  title: string
  onClose: () => void
  onSave: () => void
  onCancel: () => void
}

export const ModalAddDuplicateDialog: React.FC<ModalAddDuplicateDialogProps> = props => {
  const { open, title, onClose, onSave, onCancel } = props
  const inputRef = useRef<HTMLInputElement | null>(null)
  const translation = useContext(LanguageContext)

  const handleClose = (event: React.MouseEvent<HTMLInputElement>, reason: 'backdropClick') => {
    if (reason === 'backdropClick') return
    onClose()
  }

  const handleCancel = () => {
    onCancel()
  }

  const handleSave = () => {
    onSave()
    onClose()
  }

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '332px',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '640px',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: '0px 2px 2px #00000014',
        }}
      >
        <Stack justifyContent="center" alignItems="center" sx={{ mt: '40px' }}> {/* ここで全体を下に */}
          <Typography
            sx={{
              mt: '20px',
              color: '#282828',
              font: 'normal normal normal 30px/46px Noto Sans JP',
              textAlign: 'center',
              mr: '50px',
              ml: '50px',
            }}
          >
            {translation['label_duplicate_word'].replace('{title}', title || '')}
          </Typography>
          <DialogActions sx={{ mt: '80px', mb: '40px' }}>
            <Button
              onClick={handleCancel}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: '#282828',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '2px solid #282828',
                borderRadius: '10px',
                mt: '5px',
                mr: '30px',
                '&:hover': {
                  background: '#FFFFFF',
                  opacity: 0.8,
                },
              }}
            >
              {translation['button_cancel']}
            </Button>
            <Button
              type="submit"
              onClick={handleSave}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: '#282828',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '2px solid #282828',
                borderRadius: '10px',
                mt: '5px',
                '&:hover': {
                  backgroundColor: '#282828',
                  opacity: 0.8,
                  boxShadow: 0,
                },
              }}
            >
              {translation['button_ok']}
            </Button>
          </DialogActions>
        </Stack>
      </Box>
    </Modal>
  )
}